exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__main.has-modal {\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n}\n.modal__main.has-modal svg {\n  width: 6rem;\n  height: 3rem;\n}\n.modal__main div[data-name=ROOM_SURFACE] {\n  display: none;\n}\n.modal__main div[data-name=SURFACE_EVAL] {\n  display: none;\n}\n.container-btn-blue {\n  left: 0;\n}", ""]);

// exports
